import script from "./RestorePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./RestorePassword.vue?vue&type=script&setup=true&lang=ts"

import "./RestorePassword.vue?vue&type=style&index=0&id=0b023051&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b023051"]])

export default __exports__